import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import { getCloudEmulationOption, CloudEmulationType, CloudEmulationOption, getDeveloperEnvironmentOption, DeveloperEnvironmentOption } from '../../components/specific/dev/AdvancedSettings/devSettings.js';

// Firebase initialization only to be used in .stories.js files.
// Do not use them in components as consuming repos should manage their own
// firebase implementation.
// Using "compat" paths in firebase v9 allows upgrading to v9 gradually
// https://firebase.google.com/docs/web/modular-upgrade
// import firebase from 'firebase/compat/app';
// import 'firebase/compat/auth';
// import 'firebase/compat/functions';
const isEmulatedFunctions = getCloudEmulationOption(CloudEmulationType.FUNCTIONS) === CloudEmulationOption.LOCAL;
const isEmulatedDbAuth = getCloudEmulationOption(CloudEmulationType.DB) === CloudEmulationOption.LOCAL;
const isProdStaging = getDeveloperEnvironmentOption() === DeveloperEnvironmentOption.PRODUCTION;
const isProdDeployment = process.env.VUE_APP_ENV === 'PRODUCTION';
const isProd = isProdDeployment || isProdStaging;
const devDbUrl = 'https://caresend-dev-default-rtdb.firebaseio.com';
const emulatedDbUrl = 'http://localhost:9000/?ns=caresend-dev-default-rtdb';
const devConfig = {
    apiKey: 'AIzaSyBpk7NbrBG6ilKSb7VB87qFZua-2BZ94sc',
    authDomain: 'caresend-dev.firebaseapp.com',
    databaseURL: isEmulatedDbAuth ? emulatedDbUrl : devDbUrl,
    projectId: 'caresend-dev',
    storageBucket: 'caresend-dev.appspot.com',
    messagingSenderId: '1051154823910',
    appId: '1:1051154823910:web:9349140724146c35e21927',
    measurementId: 'G-3H0TZZEQME',
};
const prodConfig = {
    apiKey: 'AIzaSyCRVpNynRzcw2YiT-5VJSCkJi80grg1TBw',
    authDomain: 'caresend-prod.firebaseapp.com',
    projectId: 'caresend-prod',
    storageBucket: 'caresend-prod.appspot.com',
    messagingSenderId: '939913506445',
    appId: '1:939913506445:web:00542a5c10af31629d7cc4',
    measurementId: 'G-R171LCEMB9',
};
const firebaseApp = initializeApp(isProd ? prodConfig : devConfig);
// App Check is disabled for now
// initAppCheck(firebaseApp, isProd);
const firebaseAuth = getAuth(firebaseApp);
const firebaseDb = getDatabase(firebaseApp);
const firebaseFunctions = getFunctions(firebaseApp);
const firebaseStorage = getStorage(firebaseApp);
const emulateReminder = 'Ensure the correct emulators are running in cloud.';
if (isEmulatedFunctions) {
    console.info(`Using emulated Firebase Functions (localhost:5001). ${emulateReminder}`);
    connectFunctionsEmulator(firebaseFunctions, 'localhost', 5001);
}
if (isEmulatedDbAuth) {
    console.info(`Using emulated Firebase Realtime Database (localhost:9000). ${emulateReminder}`);
    connectDatabaseEmulator(firebaseDb, 'localhost', 9000);
    console.info(`Using emulated Firebase Authentication (localhost:9099). ${emulateReminder}`);
    connectAuthEmulator(firebaseAuth, 'http://localhost:9099');
}
/**
 * Call in the root typescript file (`main.ts` or `preview.ts` in storybook)
 * to ensure this file is executed.
 */
const initFirebase = () => { };

export { firebaseAuth, firebaseDb, firebaseFunctions, firebaseStorage, initFirebase, isEmulatedDbAuth, isEmulatedFunctions, isProd, isProdDeployment };
